/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AutoComplete,
  Breadcrumb,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
} from 'antd';
import { MainLayout } from 'components';
import { Content } from 'antd/lib/layout/layout';
import { Link, useHistory } from 'react-router-dom';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import { AddFillIcon } from 'assets/svg';
import { useMutation } from 'react-query';
import { openNotificationWithIcon } from 'utils/notification';
import BrandApi from 'apis/BrandApi';
import { IBrand, IPostEmailQuery } from 'interface/brand.interface';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import handleError401 from 'utils/handleError401';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { CloseSquareFilled } from '@ant-design/icons';
import CreateBrandDetail from 'components/Modules/Setting/Brand/CreateBrandDetail';
import pageTitleStore from 'store/pageTitleStore';
import { useUser } from 'contexts/User';
import { IUser } from 'interface/user.interface';

interface IProps {
  location: any;
}
export default function AddBrandPage(props: IProps): JSX.Element {
  const [form] = Form.useForm();
  const { user } = useUser();

  const history = useHistory();
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [brandData, setBrandData] = useState<any>(props.location.state);
  // const [checkGrpName] = useState<any>(props?.location?.state?.grp_name);
  // const [emailDrop, setEmailDrop] = useState<any[]>(
  //   props?.location?.state?.list_user_drop
  // );
  const handleBack = () => {
    history.push('/brand');
  };

  const { mutate: createBrand } = useMutation(BrandApi.postBrand, {
    onSuccess: (data: any) => {
      const emailsForm = form.getFieldValue('emails');

      const emails = emailsForm.map((value: any) => ({
        pro_grp_id: data?.id,
        pro_grp_level: 3,
        user_id: Number(value.split(' - ')[0]),
        email: value.split(' - ')[1],
      }));

      console.log(emails);
      createEmailBrand(emails);
    },
    onError: () => {
      openNotificationWithIcon('error', 'Cập nhật thất bại');
    },
  });

  const { mutate: createEmailBrand } = useMutation(
    BrandApi.createListEmailBrand,
    {
      onSuccess: (data: any) => {
        if (data.status === 200) {
          openNotificationWithIcon('success', 'Thêm mới thành công');
          history.push('/brand');
        }
      },
      onError: () => {
        openNotificationWithIcon('error', 'Thêm mới thất bại');
      },
    }
  );

  // useEffect(() => {
  //   if (emailDrop != undefined) setOptions(getPanelValue(emailDrop));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleCreataData = async () => {
    createBrand(brandData);
  };
  // const [options, setOptions] = useState<{ value: any; label: string }[]>([]);

  // const mockVal = (listData: any) => {
  //   return {
  //     label:
  //       listData.fullName +
  //       ' - ' +
  //       listData.jobTitle +
  //       ' - ' +
  //       listData.departmentName,
  //     value: listData.id + ' - ' + listData.email,
  //   };
  // };
  // const getPanelValue = (data: any) => {
  //   const dataOptions = [];
  //   for (let i = 0; i < data.length; i++) {
  //     dataOptions.push(mockVal(data[i]));
  //   }
  //   return dataOptions;
  // };

  function handleOnchangeBrandName(event: any, action: any) {
    setBrandData({ [action]: event?.target?.value });
  }

  useEffect(() => {
    setTitle('Tạo mới');
    setBreadcrumb([
      { title: <a href="/brand">Bộ phận phát triển</a> },
      { title: <a href="">Tạo mới</a> },
    ]);
  }, []);

  return (
    <MainLayout isLoading={false}>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <Form
            form={form}
            layout="vertical"
            className="items-center"
            autoComplete="off"
          >
            <Row gutter={8}>
              <Col className="gutter-row" span={12}>
                <Form.Item<IBrand> label="Bộ phận phát triển">
                  <Input
                    onChange={(event) => {
                      handleOnchangeBrandName(event, 'grp_name');
                    }}
                    defaultValue={brandData?.grp_name}
                    placeholder="Nhập tên danh mục"
                  />
                </Form.Item>
              </Col>
            </Row>
            <CreateBrandDetail form={form} />
          </Form>
        </Content>
      </div>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col className="flex justify-end" span={8}>
          <Space>
            <Button
              onClick={handleBack}
              bgColor={'white'}
              color={'primary'}
              border={'primary'}
            >
              Trở lại
            </Button>
            <Button onClick={handleCreataData} border={'primary'}>
              Tạo
            </Button>
          </Space>
        </Col>
      </Row>
    </MainLayout>
  );
}
